import { ConfigData, CountdownPosition, TextAlignment, TimerMode, TimerType } from '@/types';

export const DEFAULT_CONFIG: ConfigData = {
	enable_timer: true,
	name: '',
	priority: 1,
	timer_type: TimerType.BAR,
	display_at: 'home',
	categories: [],
	specificPages: [],
	products: [],
	countdown_mode: 'start-to-finish',
	time_frame_type: 'days',
	interactivity: 'none',
	title: 'Do not miss out!',
	subtitle: 'Last days to grab amazing deals before the sale ends!',
	show_days: true,
	days_label: 'Days',
	show_hours: true,
	hours_label: 'Hours',
	show_minutes: true,
	minutes_label: 'Minutes',
	show_seconds: true,
	seconds_label: 'Seconds',
	button_text: 'Shop now!',
	font: 'arial',
	background_color: '#0C1839',
	timer_window_color: '#172B61',
	countdown_color: '#D1FF53',
	time_units_color: '#A1B2D9',
	title_font_style: '24px bold #4FB0FF',
	subtitle_font_style: '16px italic #A1B2D9',
	button_bg_color: '#D1FF53',
	button_text_color: '16px bold #0C1839',
	text_alignment: TextAlignment.LEFT,
	timer_mode: TimerMode.HIDE,
	countdown_position: CountdownPosition.RIGHT_OF_TITLE,
	sticky_timer: true,
	template_id: null,
	background_image: null,
	original_image_name: null,
	mobile_use_desktop_settings: true,
	mobile_appearance: null,
};
